import type { RewardsVipTiersResponse } from "@apps/rewards/modules/VipTiers/models/RewardsVipTiersEntities";
import type { SdkMethodPayloadInterface } from "@modules/sdk/methods/SdkMethodPayloadInterface";

import { REWARDS_SDK_METHODS } from "../constants";

class GetRewardsVipTiersSdkMethodPayload
    implements SdkMethodPayloadInterface<RewardsVipTiersResponse>
{
    public readonly methodName: REWARDS_SDK_METHODS.GET_REWARDS_VIP_TIERS;

    constructor(
        public readonly locale: string,
        public readonly onSuccess: (result: RewardsVipTiersResponse) => void,
        public readonly onError: (error: Error) => void
    ) {
        this.methodName = REWARDS_SDK_METHODS.GET_REWARDS_VIP_TIERS;
        this.locale = locale;
        this.onSuccess = onSuccess;
        this.onError = onError;
    }
}

export default GetRewardsVipTiersSdkMethodPayload;
